import { api } from "../../lib/api";
export const createNewProject = async (queryParams, createProjectRequest) => {
    const params = new URLSearchParams();
    if ("partyNumber" in queryParams) {
        params.append("partyNumber", queryParams.partyNumber);
    }
    else if ("downSelectPartyNumber" in queryParams) {
        params.append("downSelectPartyNumber", queryParams.downSelectPartyNumber);
    }
    const { data, headers } = await api.post(`/projects${params.toString() ? "?" + params.toString() : ""}`, createProjectRequest);
    // add projectID to data from respone header if is not sent in body
    if (headers["projectId"] !== undefined || data.projectId === undefined) {
        data.projectId = headers["projectId"];
    }
    return { projectId: data.projectId };
};
export const getProjectDetails = async (projectId, queryParams) => {
    const params = new URLSearchParams();
    if ("partyNumber" in queryParams) {
        params.append("partyNumber", queryParams.partyNumber);
    }
    else if ("downSelectPartyNumber" in queryParams) {
        params.append("downSelectPartyNumber", queryParams.downSelectPartyNumber);
    }
    const { data } = await api.get(`/projects/${projectId}${params.toString() ? "?" + params.toString() : ""}`);
    return data;
};
